(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  /**
   * This script appends the size filter parameters from the referrer URL to the "Shop by Size" page links, if the user navigated from a page with matching parameters.
   * It checks if the current page is the "Shop by Size" page and if the referrer URL matches the previous page parameter before modifying the links.
   */
  (function () {
    if (!window.location.pathname.startsWith('/pages/shop-by-size')) {
      return;
    }

    const previousPage = new URLSearchParams(window.location.search).get('previousPage');
    const previousPagePath = previousPage ? new URL(previousPage, window.location.origin).pathname : null;
    if (!previousPagePath) {
      return;
    }

    const referrer = document.referrer;
    if (!referrer) {
      return;
    }

    const referrerUrl = new URL(referrer);
    if (referrerUrl.pathname !== previousPagePath) {
      return;
    }

    document.querySelectorAll('.shop-by-size a[href]').forEach(function (link) {
      let linkUrl;
      try {
        linkUrl = new URL(link.href);
      } catch (e) {
        return;
      }

      const sizeValues = linkUrl.searchParams.getAll('filter.v.option.size');
      if (!sizeValues.length) {
        return;
      }

      const newUrl = new URL(referrerUrl.pathname, referrerUrl.origin);
      referrerUrl.searchParams.forEach(function (value, key) {
        newUrl.searchParams.append(key, value);
      });

      sizeValues.forEach(function (size) {
        newUrl.searchParams.append('filter.v.option.size', size);
      });

      link.href = newUrl.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
